import { useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import type { ShareChannel } from 'src/app/pages/psf/promoteOrShare/shared/types';
import { useFilteredShareChannels } from 'src/app/shared/hooks/share';

import { usePsfPromoteOrShareChannelRemap } from '../usePsfPromoteOrShareChannelRemap';

export function useShareChannels(): readonly ShareChannel[] {
	const {
		data: { isTikTokChannelEnabled, shareChannelList, globalChannelList },
	} = usePsfPromoteOrSharePageData();

	const channels = shareChannelList.length ? shareChannelList : globalChannelList;

	const filters = useMemo(
		() => ({
			tiktok: isTikTokChannelEnabled,
		}),
		[isTikTokChannelEnabled],
	);

	const remappedShareChannels = usePsfPromoteOrShareChannelRemap(channels);
	return useFilteredShareChannels(remappedShareChannels, filters, { default: true });
}
